/**
 * Icon per right-sidebar surface.
 *
 * Lives beside the VM rather than inside the shell because two components draw
 * the same surface — the compact tab strip and the empty-state launcher grid —
 * and a surface that carries a different glyph in each place reads as two
 * different features.
 */
import {
  BotIcon,
  ClipboardListIcon,
  DiffIcon,
  FileTextIcon,
  FilesIcon,
  GlobeIcon,
  GitPullRequestIcon,
  ListTodoIcon,
  MonitorIcon,
  PaletteIcon,
  SmartphoneIcon,
  SquareTerminalIcon,
} from "lucide-react";

import type { RightPanelKind } from "../rightPanelSurface";

export const RIGHT_SIDEBAR_TAB_ICON: Record<RightPanelKind, typeof GlobeIcon> = {
  preview: GlobeIcon,
  terminal: SquareTerminalIcon,
  canvas: PaletteIcon,
  diff: DiffIcon,
  plan: ClipboardListIcon,
  task: ListTodoIcon,
  simulator: SmartphoneIcon,
  display: MonitorIcon,
  agents: BotIcon,
  file: FileTextIcon,
  files: FilesIcon,
  "pull-request": GitPullRequestIcon,
};
